import { customerCellText } from '../derive.ts';
import type { UsersTableRow } from '../types.ts';

/**
 * Customer column: which customer's data the user can see, and nothing else.
 * Never a property name (two users at different customers used to render
 * identical cells) and never a count — several customers are all listed.
 *
 * "N/A" is a Metron user with no grant, who needs no customer; "Unassigned" is
 * an outside user who can see nothing, which is the actionable state the old
 * combined "No Customer" cell hid.
 *
 * No icon: the building glyph crowded the cell and carried no information the
 * name does not already give.
 */
export function CustomerCell({ row }: { row: UsersTableRow }) {
  const state = row.customerState;
  const text = customerCellText(state);

  switch (state.kind) {
    case 'named':
      return <span className='text-sm'>{text}</span>;
    case 'multiple':
      return <span className='text-sm'>{text}</span>;
    default:
      return <span className='text-sm text-muted-foreground'>{text}</span>;
  }
}
